import BaseModal from 'components/Modals/BaseModal';
import SearchBar from 'components/SearchBar/SearchBar';
import { useState } from 'react';
import { Button } from 'react-bootstrap';

export default function CameraSelectModal({
  open,
  selectedPanelIndex,
  selectedCameraIds,
  cameras,
  isLoading,
  isError,
  onRetry,
  onClose,
  onSelect,
  onExited,
  widgetRuntime,
}) {
  const [search, setSearch] = useState('');
  const availableCameras = cameras.filter(
    (camera) =>
      camera.device_type === 'Overwatch VMS' &&
      !selectedCameraIds.some(
        (cameraId, index) =>
          index !== selectedPanelIndex &&
          cameraId !== null &&
          String(cameraId) === String(camera.id),
      ),
  );
  const matchingCameras = availableCameras.filter((camera) =>
    String(camera.alias || '')
      .toLowerCase()
      .includes(search.trim().toLowerCase()),
  );

  return (
    <BaseModal
      size="lg"
      show={open}
      handleShow={onClose}
      onExited={onExited}
      restoreFocus={false}
      backgroundColor="white"
      closeButton={false}
      title={<span className="text-black">Select Camera</span>}
      footer={
        <Button type="button" variant="secondary" onClick={onClose}>
          Close
        </Button>
      }
      aria-label="Select camera"
      container={widgetRuntime?.isPoppedOut ? widgetRuntime.hostElement : undefined}
    >
      <div className="text-black d-flex flex-column gap-3">
        <SearchBar
          ariaLabel="Search cameras"
          placeholder="Search cameras"
          value={search}
          onChange={setSearch}
        />
        {isLoading ? (
          <p className="mb-0" role="status">
            Loading cameras…
          </p>
        ) : isError ? (
          <div role="alert">
            <p>Unable to load cameras.</p>
            <Button type="button" onClick={onRetry}>
              Retry
            </Button>
          </div>
        ) : matchingCameras.length > 0 ? (
          <ul className="list-unstyled mb-0 overflow-auto">
            {matchingCameras.map((camera) => (
              <li className="border-bottom border-black" key={camera.id}>
                <Button
                  type="button"
                  className="btn-transparent text-black text-start rounded-0 w-100"
                  onClick={() => onSelect(camera.id)}
                >
                  {camera.static_id} - {camera.alias || 'Unnamed camera'}
                </Button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="mb-0" role="status">
            {availableCameras.length === 0
              ? 'No cameras available for this panel.'
              : 'No cameras match your search.'}
          </p>
        )}
      </div>
    </BaseModal>
  );
}
